import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { fetchLogin, setLogguedUserData } from '../../reducers/commonSlice';


function Login(props) {
    const { setCurrentOption, onClose } = props;

    const [userData, setUserData] = useState({});

    const dispatch = useDispatch();
    const { t } = useTranslation();

    const onChange = (evt) => {
        const { name, value } = evt.target;
        setUserData({ ...userData, [name]: value });
    }

    const validate = async (evt) => {
        evt.preventDefault();
        const logginData = await fetchLogin(userData);
        if (logginData.status === 'ok') {
            localStorage.setItem('loggued_user', JSON.stringify({ ...logginData.data }));
            dispatch(setLogguedUserData(logginData.data));
            onClose && onClose();
        } else {
            toast(t("bad_credentials"));
        }
    }

    return (
        <div className="authentication-wrapper authentication-basic container-p-y">
            <div className="authentication-inner">
                <div className="card">
                    <div className="card-body">
                        <div className="app-brand justify-content-center">
                            <a href="index.html" className="app-brand-link gap-2">
                                <span className="app-brand-logo demo">

                                </span>
                                <span className="app-brand-text demo text-body fw-bolder">G360</span>
                            </a>
                        </div>
                        <h4 className="mb-2">{t("login_welcome")}👋</h4>
                        <p className="mb-4">{t("login_welcome_message")}</p>

                        <form id="formAuthentication" className="mb-3">
                            <div className="mb-3">
                                <label htmlFor="email" className="form-label">{t("login_user")}</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="email"
                                    name="username"
                                    placeholder={t("login_user_placeholder")}
                                    autoFocus
                                    onChange={onChange}
                                />
                            </div>
                            <div className="mb-3 form-password-toggle">
                                <div className="d-flex justify-content-between">
                                    <label className="form-label" htmlFor="password">{t("login_password")}</label>

                                </div>
                                <div className="input-group input-group-merge">
                                    <input
                                        type="password"
                                        id="password"
                                        className="form-control"
                                        name="password"
                                        placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                                        aria-describedby="password"
                                        onChange={onChange}
                                    />
                                    <span className="input-group-text cursor-pointer"><i className="bx bx-hide"></i></span>
                                </div>
                                <a href="auth-forgot-password-basic.html">
                                    <small>{t("login_forgot_password")}</small>
                                </a>
                            </div>
                            <div className="mb-3">
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" id="remember-me" />
                                    <label className="form-check-label" htmlFor="remember-me">{t("login_remember_me")}</label>
                                </div>
                            </div>
                            <div className="mb-3">
                                <button className="btn btn-primary d-grid w-100" onClick={validate}>{t("login_signin")}</button>
                            </div>
                            <div className="mb-3">
                                <button className="btn btn-secondary d-grid w-100" onClick={() => { onClose ? onClose() : setCurrentOption('main') }}>{t("login_cancel")}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;